import React, { useEffect, useRef, useState } from "react";
import Image from "../../../../Elements/Image/Image.tsx";
import Icon from "../../../../Elements/Icon/Icon.tsx";
import useMediaQueries from "../../../../../hooks/useMediaQueries.js";
import BrandingRemoveModal from "../../Branding/BrandingRemoveModal.js";
import { ContactElementModal } from "./ContactElementModal/index.tsx";
import Tooltip from "components/Elements/Tooltip/Tooltip.js";
import CheckboxElement from "components/Elements/CheckboxElement/CheckboxElement.js";
import LoadingImageElement from "components/Elements/LoadingContainerElement/LoadingImageElement.tsx";
import { useUser } from "../../../../../contexts/userContext/userContext.js";
import { useModal } from "../../../../../contexts/modalContext/modalContext.js";
import { useContent } from "../../../../../contexts/contentContext/contentContext.js";
import { useToasts } from "react-toast-notifications";
import {
  deleteUserContactItemDataByIdReact,
  ReactUpdateContact,
} from "../../../../Pages/Inbox/Contacts/ApiContactCalles.js";

import "../../../Inbox/Popups/Popups.scss";

const ActionsContainer = ({
  hover,
  showPopup,
  setShowPopup,
  details,
  defaultAvatar,
  setContactList,
  contactList,
  setContactsQuantity,
  setCurrentPage,
  currentPage,
  setReloadContactList,
  countFavoritesUsers,
  index,
}) => {
  const { addToast } = useToasts();

  const editParentRef = useRef();
  const { setModal, closeModal } = useModal();
  const { getTextByKey } = useContent();
  const { desktopCondition } = useMediaQueries();
  const { getUserData } = useUser();
  const userData = getUserData();
  const saveContactDetails = () => {
    if (showPopup) {
      //formRef.current.dispatchEvent(new Event("submit", { cancelable: true }));
    }
    setShowPopup((prev) => {
      return prev === "edit" ? null : "edit";
    });
  };

  const deleteContact = async () => {
    //delete the contact
    const res = await deleteUserContactItemDataByIdReact({
      contactListId: details.contact_list_id,
      setReloadContactList: setReloadContactList,
    });

    if (res.status === "success") {
      addToast(getTextByKey("contact-remove-success"), {
        appearance: "success",
      });
    }
    closeModal();
  };

  const openDeleteContactModal = () => {
    setModal(() => (
      <BrandingRemoveModal
        titleModal={getTextByKey("remove-contact-text")}
        handleClick={deleteContact}
      />
    ));
  };
  const handleChangeFavortie = () => {
    //change the favorite status
    let allowChange = true;
    //check if countFavoritesUsers is <= 5
    if (!details.contact_list_favorite) {
      //countFavoritesUsers
      if (countFavoritesUsers >= 5) {
        allowChange = false;
        addToast(getTextByKey("max-favorites"), {
          appearance: "error",
        });
      }
    }
    if (allowChange) {
      const body = {
        contactListId: details.contact_list_id,
        ContactListFavorite: !details.contact_list_favorite,
        ContactName: details.contact_list_full_name,
        Email: details.contact_list_email,
        PhoneNumber: details.contact_list_phone,
      };
      ReactUpdateContact({
        formBody: body,
        setContactList: setContactList,
        contactList: contactList,
      }).then((res) => {
        res.status === "success" &&
          addToast(
            getTextByKey(
              !details.contact_list_favorite
                ? "favorites-add-success"
                : "favorites-remove-success"
            ),
            {
              appearance: "success",
            }
          );
      });
    }
  };

  const openEditModal = (item) => {
    setModal({
      modal: ContactElementModal,
      modalSize: "full-modal",
      props: {
        isEdit: true,
        details: item,
        countFavoritesUsers,
        handleSubmit: handleEditSubmit,
        setContactList: setContactList,
      },
    });
  };

  const handleEditSubmit = (body) => {
    let newBody = { ...body };
    newBody.contactListId = details.contact_list_id;
    return ReactUpdateContact({
      formBody: newBody,
      setContactList: setContactList,
      contactList: contactList,
    }).then((res) => {
      if (res.status === "success") {
        addToast(getTextByKey("success-edit-contact"), {
          appearance: "success",
        });
        setShowPopup(false);
        closeModal();
      } else {
        addToast(getTextByKey(res.data), {
          appearance: "error",
        });
      }
    });
  };

  return (
    <>
      <div className="contact-actions" ref={editParentRef}>
        {hover || !desktopCondition ? (
          <>
            <div className="action-container">
              <Tooltip
                id={`favorite-contact-${index}`}
                tooltipTextKey={"favorite-contact-tooltip"}
                top
              >
                <div
                  className="icon-container favorite-icon"
                  onClick={() => handleChangeFavortie()}
                >
                  {details.contact_list_favorite ? (
                    <Icon name="star-solid" />
                  ) : (
                    <Icon name="star-regular" />
                  )}
                </div>
              </Tooltip>
            </div>
            <div
              className={`action-container ${
                showPopup === "edit" ? "open-edit-modal" : ""
              }`}
            >
              <Tooltip
                id={`edit-contact-${index}`}
                tooltipTextKey={"edit-contact-tooltip"}
                top
              >
                <div className="icon-container">
                  <Icon
                    name="pancil"
                    gray={!showPopup || showPopup !== "edit"}
                    blue={showPopup === "edit"}
                    onClick={() => openEditModal(details)}
                  />
                </div>
              </Tooltip>
            </div>

            <div className="action-container">
              <Tooltip
                id={`delete-contact-${index}`}
                tooltipTextKey={"delete-contact-tooltip"}
                top
              >
                <div className="icon-container delete-icon">
                  <Icon
                    name="trash-solid-b"
                    onClick={() => openDeleteContactModal()}
                  />
                </div>
              </Tooltip>
            </div>
          </>
        ) : null}
      </div>
    </>
  );
};

const ProfileContactsElement = ({
  details,
  listView,
  setContactList,
  contactList,
  setContactsQuantity,
  setCurrentPage,
  currentPage,
  setReloadContactList,
  index,
  handleSubmit,
  countFavoritesUsers,
  selectAllContacts,
  setSelectedContactList,
  loadingDeleteContacts,
  selectedContactList,
}) => {
  const { getDirection } = useContent();
  const { newMobileCondition } = useMediaQueries();
  const defaultAvatar = "avatar_default_large";
  const [hover, setHover] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [selectContact, setSelectContact] = useState(selectAllContacts);
  useEffect(() => {
    setSelectContact(selectAllContacts);
  }, [selectAllContacts]);

  useEffect(() => {
    //setSelectedContactList
    //if selectContact is true, add the contact to the list else remove it
    if (selectContact) {
      setSelectedContactList((prev) => [...prev, details.contact_list_id]);
    } else {
      setSelectedContactList((prev) =>
        prev.filter((item) => item !== details.contact_list_id)
      );
    }
  }, [selectContact]);

  useEffect(() => {
    if (selectedContactList.length === 0) {
      setSelectContact(false);
    }
  }, [selectedContactList]);

  //contact_list_full_name
  //contact_list_email
  //contact_list_phone
  useEffect(() => {
    !showPopup && setHover(false);
  }, [showPopup]);

  const getFirstTwoLettersOfEmail = (name) => {
    if (name) {
      //if the name contain space, get the first letter of each word else get the first letter of the name
      const nameArray = name.split(" ");
      if (nameArray.length > 1) {
        return (
          nameArray[0].charAt(0).toUpperCase() +
          nameArray[1].charAt(0).toUpperCase()
        );
      } else {
        return nameArray[0].charAt(0).toUpperCase();
      }
    }
  };

  const calculateBackgroundColor = (name) => {
    let backgroundColor = "#15b4d4";
    if (name) {
      const firstLetter = name.charAt(0);
      if (firstLetter) {
        //generate color from the firstLetter
        const firstLetterCode = firstLetter.charCodeAt(0);
        backgroundColor = generateColorByCode(firstLetterCode);
      }
    }

    return backgroundColor;
  };

  //list of random colors
  const colors = [
    "#3F51B5",
    "#2196F3",
    "#9F2B68",
    "#3F51B5",
    "#00A8FF",
    "#23c23b",
    "#FF5722",
    "#F44336",
    "#4CAF50",
    "#FF9800",
  ];

  const generateColorByCode = (code) => {
    let backgroundColor = "#15b4d4";
    if (code) {
      const codeNumber = code % 10;
      backgroundColor = colors[codeNumber];
    }
    return backgroundColor;
  };

  return (
    <div
      className={`contact-item${listView ? " list" : ""} ${
        getDirection() === "rtl" ? "contact-item-rtl" : ""
      }`}
      onMouseEnter={() => {
        setHover(true);
      }}
      onMouseLeave={() => {
        !showPopup && setHover(false);
      }}
      style={{
        borderColor:
          hover &&
          calculateBackgroundColor(
            details.contact_list_full_name
              ? details.contact_list_full_name
              : details.contact_list_email
          ),
      }}
    >
      <div className="select-contact-checkbox">
        {loadingDeleteContacts &&
        selectedContactList.includes(details.contact_list_id) ? (
          <LoadingImageElement />
        ) : (
          <CheckboxElement state={selectContact} setState={setSelectContact} />
        )}
      </div>
      <div className="contact-info">
        {newMobileCondition ? (
          <>
            <div className="contact-name-and-avatar">
              <div className="contact-avatar">
                {details && details.contact_list_favorite && (
                  <div className="favorite-contact">
                    <Icon name="star-solid" />
                  </div>
                )}
                {details.contact_list_image ? (
                  <Image
                    src={
                      details && details.contact_list_image
                        ? details.contact_list_image
                        : null
                    }
                    name={!details.contact_list_image ? defaultAvatar : null}
                    ext={!details.contact_list_image && "png"}
                  />
                ) : (
                  <div
                    className="default-avatar-container"
                    style={{
                      backgroundColor: calculateBackgroundColor(
                        details.contact_list_full_name
                          ? details.contact_list_full_name
                          : details.contact_list_email
                      ),
                    }}
                  >
                    {getFirstTwoLettersOfEmail(
                      details.contact_list_full_name
                        ? details.contact_list_full_name
                        : details.contact_list_email
                    )}
                  </div>
                )}
              </div>
            </div>
            <div className="details-contact">
              <div className="contact-name">
                {details && details.contact_list_full_name
                  ? details.contact_list_full_name
                  : null}
              </div>
              <div className="contact-email">
                {" "}
                {details && details.contact_list_email
                  ? details.contact_list_email
                  : null}
              </div>
              <div className="contact-phone">
                {" "}
                {details && details.contact_list_phone
                  ? details.contact_list_phone
                  : null}
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="contact-name-and-avatar">
              <div className="contact-avatar">
                {details && details.contact_list_favorite && (
                  <div className="favorite-contact">
                    <Icon name="star-solid" />
                  </div>
                )}
                {details.contact_list_image ? (
                  <Image
                    src={
                      details && details.contact_list_image
                        ? details.contact_list_image
                        : null
                    }
                    name={!details.contact_list_image ? defaultAvatar : null}
                    ext={!details.contact_list_image && "png"}
                  />
                ) : (
                  <div
                    className="default-avatar-container"
                    style={{
                      backgroundColor: calculateBackgroundColor(
                        details.contact_list_full_name
                          ? details.contact_list_full_name
                          : details.contact_list_email
                      ),
                    }}
                  >
                    {getFirstTwoLettersOfEmail(
                      details.contact_list_full_name
                        ? details.contact_list_full_name
                        : details.contact_list_email
                    )}
                  </div>
                )}
              </div>
              <Tooltip
                tooltipTextKey={
                  details && details.contact_list_full_name
                    ? details.contact_list_full_name
                    : null
                }
              >
                <div className="contact-name">
                  {details && details.contact_list_full_name
                    ? details.contact_list_full_name
                    : null}
                </div>
              </Tooltip>
            </div>
            <div className="contact-email">
              {" "}
              {details && details.contact_list_email
                ? details.contact_list_email
                : null}
            </div>
            <div className="contact-phone">
              {" "}
              {details && details.contact_list_phone
                ? details.contact_list_phone
                : null}
            </div>
          </>
        )}
      </div>
      <div className="flex-spacer"></div>
      <ActionsContainer
        {...{
          hover,
          showPopup,
          setShowPopup,
          details,
          defaultAvatar,
          contactList,
          setContactList,
          setContactsQuantity,
          setCurrentPage,
          currentPage,
          setReloadContactList,
          index,
          handleSubmit,
          countFavoritesUsers,
        }}
      />
    </div>
  );
};

export default ProfileContactsElement;
